import { Component } from '@angular/core';
import { CommonModule, JsonPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { ToastNotifService } from '../../../../../core/services/toastNotif.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { ToastrService } from 'ngx-toastr';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CardByVehicleTypeInfo } from '../../../../../core/models/activate.model';

import Swal from 'sweetalert2';
import {
  RegisterMemberNewPayload,
  CarList,
} from '../../../../../core/models/member.model';
import { LanguageService } from '../../../../../core/services/language.service';
import { Subscription } from 'rxjs';
import { MyProfile } from '../../../../../core/models/user.model';
import {
  InformationResponse,
  VehicleDetail,
  Color,
  Province,
  StatusAPIResponse,
  TaxpayerInfo,
  InsertLicensePayload,
  InsertLicenseResponse,
} from '../../../../../core/models/information.model';
import {
  FeeDetailsResponse,
  ObjectFeeResponse,
} from '../../../../../core/models/parking.model';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatNativeDateModule,
} from '@angular/material/core';
import {
  UserVehicleResponse,
  MyVehicleAllResponse,
  MyAddressAllResponse,
} from '../../../../../core/models/user.model';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MatMomentDateModule,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import * as _moment from 'moment';
import {
  ActivateMemberPayload,
  VehicleMemberPayload,
} from '../../../../../core/models/activate.model';
import { PssLoadingComponent } from '../../../../../tools/template/pss/pss-loading/pss-loading.component';
import { ToastWarnComponent } from '../../../../../tools/template/toast/toast-warn/toast-warn.component';
import { ToastFailedComponent } from '../../../../../tools/template/toast/toast-failed/toast-failed.component';
import { ToastSuccessComponent } from '../../../../../tools/template/toast/toast-success/toast-success.component';
import { ToastCustomService } from '../../../../../tools/services/toast/toast-custom/toastCustom.service';
import { PssWarnComponent } from '../../../../../tools/template/pss/pss-warn/pss-warn.component';
import { ApiLicenseService } from '../../../../../core/services/api/Vehicle/api-license';
import { ApiMemberCardService } from '../../../../../core/services/api/Member/api-member-card';
import { ApiVehicleService } from '../../../../../core/services/api/Vehicle/api-vehicle';
import { ApiUserService } from '../../../../../core/services/api/User/api-user';
const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-active-member-card-form',
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatMomentDateModule,
    NgxMatTimepickerModule,
    PssLoadingComponent,
    PssWarnComponent,
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  templateUrl: './activate-member-card-form.component.html',
  styleUrl: './activate-member-card-form.component.css',
})
export class ActivateMemberCardFormComponent {
  // ---------------- state ---------------------
  code: string = '';
  startDate: Date | null = null;
  endDate: Date | null = null;
  siteId: number = 0;
  vehicleLimit: number = 0;
  vehicleId: number = 0;
  vehicleName: string = '';
  siteName: string = '';
  cardCode: string = '';
  CardInfo: CardByVehicleTypeInfo | null = null;
  /* ------------------- Value ------------------- */
  // ????
  userStatus: boolean = false;
  expire_date: string = '';
  popupMessage = '';
  originalDate: Date | null = null;
  expire_date_show: string = '';
  showInfoPopup = false;
  selectedColor: string | null = null;
  licenseError: string | null = null;
  customer_name: string = '';
  renew: boolean = false;

  // Language
  currentLang: 'TH' | 'EN' = 'TH';
  sub: Subscription;
  // Headers
  providerName: string = 'TEST';
  // Vehicle Count
  vehicleCount: number = 1;

  today = new Date();

  // Vehicle Plate
  carPlateList: MyVehicleAllResponse[] = [];
  carFilteredPlateList: MyVehicleAllResponse[] = [];
  remarks: string = '';
  totalCalVehicle: number = 0;
  vehicleTypeState: string = '';
  // Modal Vehicle Plate
  selectedBrand: string | null = null;
  selectedProvince: any = null;
  searchTerm: string = ''; // คำค้นหา
  ProvinceOptions: { value: string; label: string }[] = [];
  vehicleDetails: VehicleDetail[] = [];
  selectedModel: string | null = null;
  selectEngine: string | null = null;
  ModelOptions: { value: string; label: string }[] = [];
  BrandOptions: { value: string; label: string }[] = [];
  ColorOptions: { value: string; label: string }[] = [];
  license: string = '';

  // Active member card
  isDisableCheckbox: boolean = false;

  // API
  providerId: number = 0;
  token: string = '';
  uid: string = '';
  licenseAll: MyVehicleAllResponse[] = [];
  licenseFilteredCar: any[] = [];
  licenseFilteredMotorcycle: any[] = [];
  carList: CarList[] | null = null;
  selectedLicense: string = '';

  // Warn
  error: string = '';
  isLoading: boolean = false; // สถานะการโหลดข้อมูล
  isSaveLoading: boolean = false;
  isModalRenewWarn: boolean = false;

  /* ------------------- Style ------------------- */
  // Vehicle Plate
  selectCarPlate: MyVehicleAllResponse[] = [];

  // Modal Vehicle Plate
  isOpenSelectVehiclePlateModal: boolean = false;
  isOpenSelectVehicleProvince: boolean = false;

  // Modal
  showTaxModal: boolean = false;
  showModalVehiclePlate: boolean = false;
  showAddressModal: boolean = false;
  modalSelectVehicle: boolean = false;
  showModal_confirm: boolean = false;

  // Alert
  isSuccess: boolean = false;
  textSuccess: string = '';
  detailSuccess: string = '';
  isWarning: boolean = false;
  textWarn: string = '';
  detailWarn: string = '';
  isError: boolean = false;
  textError: string = '';
  detailError: string = '';

  constructor(
    private cookieService: CookieService,
    private apiLicenseService: ApiLicenseService,
    private apiVehicleService: ApiVehicleService,
    private apiMemberCardService: ApiMemberCardService,
    private apiUserService : ApiUserService,
    private toast: ToastNotifService,
    private toastCustomService: ToastCustomService,
    private router: Router,
    private http: HttpClient,

    private languageService: LanguageService
  ) {
    // Language
    this.sub = this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });

    // Toast
    this.toast = toast;

    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras.state as {
      code: string;
      startDate: Date;
      endDate: Date;
      siteId: number;
      vehicleLimit: number;
      vehicleId: number;
      vehicleName: string;
      siteName: string;
      cardCode: string;
    };
    console.log('state', state);
    if (state) {
      this.code = state.code;
      this.startDate = state.startDate;
      this.endDate = state.endDate;
      this.siteId = state.siteId;
      this.vehicleLimit = state.vehicleLimit;
      this.vehicleId = state.vehicleId;
      this.vehicleName = state.vehicleName;
      this.siteName = state.siteName;
      this.cardCode = state.cardCode;
      const today = new Date();
      today.setHours(0, 0, 0, 0); // ตัดเวลาออกเพื่อความแม่นยำ
      this.originalDate = this.startDate;
    }
  }
  ngOnInit(): void {
    this.uid =
      this.cookieService.get('line_uid') ||
      localStorage.getItem('line_uid') ||
      '';
    // JWT is HttpOnly cookie — token_user no longer used
    this.token = '';

    this.requestGetCarDetail()

    if (!this.cardCode) {
      console.log('ไม่มี cardCode', this.renew);
      setTimeout(() => {
        this.getVehicleUser();
      }, 300);
    } else {
      console.log('มี cardCode');
      setTimeout(() => {
        this.renew = true;
        this.getVehicleCard();
      }, 300);
    }
  }
  /* --------------------------------------- Function -------------------------------- */
  /* --- Style --- */
  showWarning(text: string, detail: string = '') {
    // this.toast.warning(text);
    this.toastCustomService.showWarning('', text);
  }
  showError(text: string, detail: string = '') {
    // this.toast.error(text);
    this.toastCustomService.showError('', text);
  }
  showSuccess(text: string, detail: string = '') {
    // this.toast.success(text);
    this.toastCustomService.showSuccess('', text);
  }

  // ----- Vehicle Plate -----
  toggleSelect(vehicle: MyVehicleAllResponse, event: Event) {
    event.stopPropagation(); // ป้องกันไม่ให้ blur แล้ว dropdown ปิด
    console.log('vehicle', vehicle);
    const index = this.selectCarPlate
      .map((item) => item.plate_number)
      .indexOf(vehicle.plate_number);

    // ตรวจสอบ ว่า vehicle มีใน selectCarPlate หรือไม่
    if (index > -1) {
      this.selectCarPlate.splice(index, 1);
      this.isDisableCheckbox = false;
    } else {
      // แจ้งเตือนตรวจสอบ checkbox เกินขีดจำกัด
      if (this.selectCarPlate.length >= this.vehicleLimit) {
        this.showWarning(
          this.currentLang === 'TH'
            ? 'จํานวนรถที่สามารถใช้ได้ไม่เกิน ' + this.vehicleLimit + ' รถ'
            : 'You can use up to ' + this.vehicleLimit + ' vehicles.'
        );
        return;
      }

      // เพิ่ม Model ลงใน selectCarPlate
      this.selectCarPlate.push(vehicle);

      // ตรวจสอบอีกรอบจำนวนหลัง push ไปแล้วเพื่อ css
      if (this.selectCarPlate.length >= this.vehicleLimit) {
        this.isDisableCheckbox = true;
      }

      console.log('✅ Selected Plates:', this.selectCarPlate);
    }
  }
  isSelected(plate: string): boolean {
    return this.selectCarPlate.map((item) => item.plate_number).includes(plate);
  }
  toggleModalVehiclePlate() {
    this.showModalVehiclePlate = !this.showModalVehiclePlate;

    this.filterBrandOptions(this.vehicleName || '');
  }

  // ------- Modal -------
  closeModal_Confirm() {
    this.showModal_confirm = false;
  }


  /* ------------------- Function ------------------ */

  // -------- Register Form ---------
  submitRequest() {
    console.log(this.startDate);
    if (!this.startDate) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุวันที่เริ่มต้นใช้งาน'
          : 'Please specify the start date.'
      );
    }
  }
  onClickSaveActiveMemberCard() {
    this.isSaveLoading = true;
    this.token = '';

    const date = new Date(this.startDate || '');
    date.setHours(date.getHours() + 7);

    const vehicleMember: VehicleMemberPayload[] = this.selectCarPlate.map(
      (item) => ({
        vehicleId: item.vehicle_id,
        plateNumber: item.plate_number,
      })
    );
    let payload: ActivateMemberPayload;

    if (this.renew) {
      payload = {
        uid: this.uid,
        codeMember: this.code,
        siteId: this.siteId,
        cardCode: this.cardCode,
        type: 2,
        vehicle: vehicleMember,
      };
    } else {
      payload = {
        uid: this.uid,
        codeMember: this.code,
        siteId: this.siteId,
        cardCode: '',
        type: 1,
        vehicle: vehicleMember,
      };
    }
    console.log('payload', JSON.stringify(payload));
    if (this.validateFormActiveMemberCard()) {
      this.postSaveActiveMemberCard(payload);
    }
  }
  validateFormActiveMemberCard() {
    if (!this.startDate) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุวันที่เริ่มต้นใช้งาน'
          : 'Please specify the start date.'
      );
      return false;
    } else if (this.customer_name == '') {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุชื่อผู้ใช้งาน'
          : 'Please specify the start date.'
      );
      return false;
    } else if (this.selectCarPlate.length == 0) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุทะเบียนรถ'
          : 'Please specify the start date.'
      );
      return false;
    }
    return true;
  }




  // --------- Vehicle Plate ----------
  filterCarPlate(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    this.carFilteredPlateList = this.carPlateList.filter((vehicle) =>
      vehicle.plate_number.toLowerCase().includes(searchTerm)
    );
  }

  addVehiclePlate(vehicle: MyVehicleAllResponse) {
    this.carPlateList.push(vehicle);
  }





  // -------- Modal Vehicle Plate ---------
  filterProvinces() {
    return this.ProvinceOptions.filter((ProvinceOptions) =>
      ProvinceOptions.label
        .toLowerCase()
        .includes(this.searchTerm.toLowerCase())
    );
  }
  selectProvince(province: any) {
    this.selectedProvince = province;
    this.isOpenSelectVehicleProvince = false;
    // console.log('เลือกจังหวัด:', province);
  }
  handleBrandChange(event: any): void {
    this.selectedBrand = event.target.value;
    console.log('Selected Brand ID:', this.selectedBrand);
    this.filterModelVehicleOptions(this.selectedBrand || '');
  }
  filterBrandOptions(vehicleType: string, preSelectBrand?: string): void {
    //console.log("filterBrandOptions : ", vehicleType, preSelectBrand);
    const filteredBrands = this.vehicleDetails
      .filter((vehicle) => vehicle.vehicle_type_name === vehicleType)
      .map((vehicle) => vehicle.vehicle_brand_name);

    const uniqueBrands = [...new Set(filteredBrands)];
    this.selectedBrand = '';
    this.selectedModel = '';

    this.BrandOptions = uniqueBrands.map((brand) => ({
      value: brand,
      label: brand,
    }));

    // ✅ ถ้ามีค่าที่ต้องการเลือกไว้ล่วงหน้า
    if (preSelectBrand) {
      // console.log('เลือกแบร์นมา ', preSelectBrand);
      const defaultBrand = this.BrandOptions.find(
        (opt) => opt.value === preSelectBrand
      );
      this.selectedBrand = defaultBrand ? defaultBrand.value : null;
    }
  }
  filterModelVehicleOptions(brand: string): void {
    // กรองข้อมูลตามประเภทที่เลือก
    const filteredModel = this.vehicleDetails
      .filter(
        (brands) =>
          brands.vehicle_brand_name === brand &&
          brands.vehicle_type_name === this.vehicleName
      ) // กรองตามประเภทที่เลือก
      .map((brands) => brands.vehicle_model_name);
    console.log("filteredModel", filteredModel);

    // กรองค่าซ้ำจาก filteredBrands
    const uniqueBrands = [...new Set(filteredModel)];
    this.selectedModel = '';
    this.selectEngine = '';

    // อัปเดต ModelOptions โดยใช้ค่าที่ไม่ซ้ำดอ
    this.ModelOptions = uniqueBrands.map((model) => ({
      value: model,
      label: model,
    }));
  }

  handleModelChange(event: any): void {
    this.selectedModel = event.target.value;
    this.selectEngine = '';
    console.log('Selected Model ID:', this.selectedModel);

    const filteredEngines = this.vehicleDetails
      .filter(
        (brands) =>
          brands.vehicle_brand_name === this.selectedBrand &&
          brands.vehicle_type_name === this.vehicleName &&
          brands.vehicle_model_name === this.selectedModel
      ) // กรองตามประเภทที่เลือก
      .map((brands) => brands.vehicle_engine_name);

    this.selectEngine = filteredEngines[0] || '';
    console.log('Selected Engine:', this.selectEngine);
  }
  handleColorChange(event: any): void {
    this.selectedColor = event.target.value;
    console.log('Selected Color ID:', this.selectedColor);
  }

  submitModalVehiclePlate() {
    if (!this.license || this.licenseError) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณากรอกทะเบียนรถ'
          : 'Please specify the vehicle registration.'
      );
    } else if (this.selectedProvince == null) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุจังหวัด'
          : 'Please specify the province.'
      );
    }
    // else if (this.selectedBrand == '') {
    //   this.showWarning(
    //     this.currentLang === 'TH'
    //       ? 'กรุณาเลือกยี่ห้อ'
    //       : 'Please select the brand.'
    //   );
    // } 
    // else if (this.selectedModel == '') {
    //   this.showWarning(
    //     this.currentLang === 'TH'
    //       ? 'กรุณาเลือกรุ่น'
    //       : 'Please select the model.'
    //   );
    // } 
    // else if (this.selectedColor == '') {
    //   this.showWarning(
    //     this.currentLang === 'TH'
    //       ? 'กรุณาเลือกสีของรถ'
    //       : 'Please select the color.'
    //   );
    // } 
    else {
      const payload: InsertLicensePayload = {
        uid: this.uid,
        license: this.license.replace(/\s+/g, ''),
        vehicle_type: this.vehicleName || '',
        brand: /*this.selectedBrand ||*/ this.vehicleName == "รถยนต์" ? 'Acura' : 'Honda',
        model: /*this.selectedModel ||*/ this.vehicleName == "รถยนต์" ? 'Integra' : 'ADV160',
        engine_type: this.selectEngine || '',
        color: /*this.selectedColor || */this.vehicleName == "รถยนต์" ? 'ดำ' : 'ดำ',
        province: this.selectedProvince.value,
      };
      if (payload) {
        // console.log('payload', JSON.stringify(payload, null, 2));
        this.apiLicenseService.insertLicense(payload, this.token).subscribe({
          next: (res: InsertLicenseResponse) => {
            console.log('📦 Response:', res);
            if (res.code == '000') {
              this.isSaveLoading = false;
              this.getVehicleUser();
              this.showSuccess(
                this.currentLang === 'TH'
                  ? 'บันทึกสำเร็จ'
                  : 'Saved successfully.'
              );
              this.showModalVehiclePlate = false;
            } else {
              this.showError(
                this.currentLang === 'TH'
                  ? 'บันทึกไม่สำเร็จ'
                  : 'Save not successful.'
              );
            }
          },
          error: (err) => {
            console.error('❌ ส่ง OTP ไม่สำเร็จ:', err);
            this.showError(
              this.currentLang === 'TH'
                ? 'บันทึกไม่สำเร็จ'
                : 'Save not successful.'
            );
            this.isSaveLoading = false;
          },
          complete: () => {
            this.isSaveLoading = false;
          },
        });
      } else {
        console.log('No payload Data');
      }
    }
  }






  // -------- Modal Vehicle Select Plate ---------
  decreaseVehicleCount(): void {
    this.vehicleCount = Math.max(this.vehicleCount - 1, 1);
  }
  goback() {
    this.router.navigate(['/activate-member-card']);
  }

  /* ---------------------------------------- API ----------------------------------------------- */

  // ----- Form ----
  postSaveActiveMemberCard(payload: ActivateMemberPayload) {
    this.closeModal_Confirm();
    this.isLoading = true;
    this.apiMemberCardService.postSaveActiveMemberCard(this.token, payload).subscribe({
      next: (response: StatusAPIResponse) => {
        this.isLoading = false;
        // console.log('API response:', response);
        if (response.code === '000') {
          this.showSuccess(
            this.currentLang === 'TH' ? response.message : response.message_en
          );
          this.goback();
        } else {
          this.showError(
            this.currentLang === 'TH' ? response.message : response.message_en
          );
        }
      },
      error: (error) => {
        this.isLoading = false;
        console.error('API error:', error);
        this.showError(
          this.currentLang === 'TH'
            ? 'บันทึกไม่สําเร็จ'
            : 'Save not successful.'
        );
      },
    });
  }

  // -------- Modal Vehicle Plate ---------
  requestGetCarDetail() {
    this.isLoading = true;
    // console.log('Token:', this.token);
    this.apiVehicleService.getCarDetail(this.token).subscribe({
      next: (response: InformationResponse) => {
        console.log('getCarDetail :', response);
        this.vehicleDetails = response.vehicle_detail;
        this.ColorOptions = response.color.map((color: Color) => ({
          value: color.name.toLowerCase(),
          label: color.name,
        }));
        this.ProvinceOptions = response.province.map((province: Province) => ({
          value: province.name.toLowerCase(),
          label: province.name,
        }));
        this.getVehicleUser();
        this.isLoading = false;
      },
      error: (error) => {
        console.error('API error:', error);
        this.isLoading = false;
      },
    });
  }

  getVehicleUser() {
    setTimeout(() => {
      this.getProfile();
      this.getUserVehicleAll();
    }, 100);
  }

  getVehicleCard() {
    setTimeout(() => {
      this.getProfile();
      this.getUserVehicleByCard();
      this.getCardInfo();
    }, 100);
  }

  getUserVehicleAll() {
    this.apiVehicleService
      .getVehicleUserAllBySite(this.token, this.uid, this.siteId)
      .subscribe({
        next: (response: MyVehicleAllResponse[]) => {
          console.log(response);
          this.setValueVehicle(response);
        },
        error: (error) => {
          console.error('API error:', error);
          this.isLoading = false;
        },
      });
  }

  getCardInfo() {
    this.apiMemberCardService
      .getCardInfoByCardCode(this.uid, this.siteId, this.cardCode, this.token)
      .subscribe({
        next: (response: CardByVehicleTypeInfo) => {
          console.log(response);
          this.CardInfo = response;
        },
        error: (error) => {
          console.error('API error:', error);
          this.isLoading = false;
        },
      });
  }

  getUserVehicleByCard() {
    this.apiMemberCardService
      .getVehicleMemberCardInfo(
        this.token,
        this.uid,
        this.siteId,
        this.cardCode
      )
      .subscribe({
        next: (response: MyVehicleAllResponse[]) => {
          console.log(response);
          this.setValueVehicle(response);
          response.forEach((response) => {
            this.selectCarPlate.push(response);
          });
        },
        error: (error) => {
          console.error('API error:', error);
          this.isLoading = false;
        },
      });
  }

  setValueVehicle(response: MyVehicleAllResponse[]) {
    // --- กรองข้อมูลทะเบียนรถ ---
    this.licenseAll = response;

    // ใส่ป้ายทะเบียนเริ่มต้น
    this.carPlateList = this.licenseAll.filter(
      (item) => item.vehicle_type_name === this.vehicleName
    );
  }

  getProfile() {
    this.isLoading = true;
    this.apiUserService.GetProfile(this.token, this.uid).subscribe({
      next: (response: MyProfile) => {
        console.log(response);
        this.isLoading = false;
        if (response) {
          this.customer_name = response.fullName;
        } else {
          console.log('No data');
        }
      },
      error: (error) => {
        console.error('API error:', error);
        this.isLoading = false;
      },
    });
  }
}
